import { useCallback } from 'react';
import {
    getFoldersForImplant,
    setFoldersForImplant,
} from '../../services/api/folderService';
import { FolderPickerDialog } from './FolderPickerDialog';

interface FoldersForImplantDialogProps {
    implantId: string;
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onChanged?: () => void;
}

export const FoldersForImplantDialog = ({
    implantId,
    open,
    onOpenChange,
    onChanged,
}: FoldersForImplantDialogProps) => {
    const load = useCallback(async () => {
        const folders = await getFoldersForImplant(implantId);
        return {
            folders,
            selectedIds: folders.filter((f) => f.hasImplant).map((f) => f._id),
        };
    }, [implantId]);

    const apply = useCallback(
        (folderIds: string[]) => setFoldersForImplant(implantId, folderIds),
        [implantId]
    );

    return (
        <FolderPickerDialog
            open={open}
            onOpenChange={onOpenChange}
            load={load}
            apply={apply}
            onApplied={() => onChanged?.()}
        />
    );
};
